import React from 'react';
import PropTypes from 'prop-types';

import { Stepper as MUIStepper, StepConnector as MUIStepConnector } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

// v5 removed Stepper's own default root padding (v4 always had a fixed 24px on all sides) —
// restored here so the stepper isn't flush against its container's edges.
const useStyles = makeStyles()({
  root: {
    padding: '24px'
  },
  // v5 also dropped the vertical connector's own 8px bottom padding (v4 always had it),
  // making vertical steps sit closer together than before.
  connectorVertical: {
    padding: '0 0 8px'
  }
});

export const Stepper = props => {
  const { classes } = useStyles();
  return (
    <MUIStepper
      connector={<MUIStepConnector classes={{ vertical: classes.connectorVertical }} />}
      {...props}
      classes={{ root: classes.root, ...props.classes }}
    />
  );
};

Stepper.propTypes = {
  activeStep: PropTypes.number,
  alternativeLabel: PropTypes.bool,
  classes: PropTypes.object,
  connector: PropTypes.node,
  nonLinear: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};

export default Stepper;
